// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store }  from './store'
import Notifications from 'vue-notification'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import Fragment from 'vue-fragment'
import BackContainer from './components/ReUse/BackContainer.vue';
import './assets/css/styles.scss'

Vue.use(Notifications)
Vue.config.productionTip = false
Vue.use(Datepicker);
Vue.use(moment);
Vue.use(Fragment.Plugin)
Vue.prototype.moment = moment
Vue.component("back-container",BackContainer);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
